import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import loadable from "@loadable/component";
import { useEffect, useState } from "react";
import stl from "./UnbxdAsideFilters.module.css";
import useIsMobile from "@hooks/useIsMobile";
import { useLocation } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import { isRangeFilter, prepareDeletedFilters, validateFilters } from "@/pages/search/searchHooks/utils";
import AsideFilterLoading from "./components/AsideFilterLoading/AsideFilterLoading";
import AsideHeader from "./components/AsideHeader/AsideHeader";
import { buildSearchParams, getSubMenuHeight } from "@/pages/search/searchHooks/filtersHelpers";
import SaveSearchBanner from "@/components/SearchComponent/UnbxdComponents/UnbxdSaveSearch/SaveSearchBanner";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import useFilterPage from "@/pages/search/searchHooks/useSearchAndFilters";
var fallback = {
  fallback: null
};
var AsideBody = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-AsideBody-AsideBody";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-AsideBody-AsideBody" */"./components/AsideBody/AsideBody");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/AsideBody/AsideBody");
    }
    return eval('require.resolve')("./components/AsideBody/AsideBody");
  }
}, fallback);
var MobileFilters = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-MobileFilters-MobileFilters";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-MobileFilters-MobileFilters" */"./components/MobileFilters/MobileFilters");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/MobileFilters/MobileFilters");
    }
    return eval('require.resolve')("./components/MobileFilters/MobileFilters");
  }
}, fallback);
var AsideTags = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-AsideTags-AsideTags";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-AsideTags-AsideTags" */"./components/AsideTags/AsideTags");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/AsideTags/AsideTags");
    }
    return eval('require.resolve')("./components/AsideTags/AsideTags");
  }
}, fallback);
var AsideSubMenu = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-AsideSubMenu-AsideSubMenu";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-AsideSubMenu-AsideSubMenu" */"./components/AsideSubMenu/AsideSubMenu");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/AsideSubMenu/AsideSubMenu");
    }
    return eval('require.resolve')("./components/AsideSubMenu/AsideSubMenu");
  }
}, fallback);
var AsideFooter = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "components-AsideFooter-AsideFooter";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "components-AsideFooter-AsideFooter" */"./components/AsideFooter/AsideFooter");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("./components/AsideFooter/AsideFooter");
    }
    return eval('require.resolve')("./components/AsideFooter/AsideFooter");
  }
}, fallback);
function UnbxdAsideFilters(_ref) {
  var filters = _ref.filters,
    selectedOptions = _ref.selectedOptions,
    sort = _ref.sort,
    loading = _ref.loading,
    showFilters = _ref.showFilters,
    setShowFilters = _ref.setShowFilters,
    dealFacet = _ref.dealFacet,
    postsCount = _ref.postsCount,
    searchTerm = _ref.searchTerm,
    metaData = _ref.metaData;
  var location = useLocation();
  var _useState = useState(null),
    openedFilter = _useState[0],
    setOpenedFilter = _useState[1];
  var _useState2 = useState([]),
    tempSelectedOptions = _useState2[0],
    setTempSelectedOptions = _useState2[1];
  var _useState3 = useState(false),
    showAllTags = _useState3[0],
    setShowAllTags = _useState3[1];
  var isMobile = useIsMobile();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useFilterPage = useFilterPage(),
    isSearchSaved = _useFilterPage.isSearchSaved;
  var handleOpenFilter = function handleOpenFilter(clickedFilter) {
    setOpenedFilter(clickedFilter);
    var tempSelectedOptions = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.filter(function (option) {
      return (option === null || option === void 0 ? void 0 : option.filterField) === (clickedFilter === null || clickedFilter === void 0 ? void 0 : clickedFilter.filterField);
    });
    setTempSelectedOptions(tempSelectedOptions);
  };
  var handleCloseFilter = function handleCloseFilter() {
    setTempSelectedOptions([]);
    setOpenedFilter(null);
  };
  var handleFilterChange = function handleFilterChange(filter, selectedOption, isDirectSearch) {
    var isRange = isRangeFilter(filter === null || filter === void 0 ? void 0 : filter.filterField);
    if ((filter === null || filter === void 0 ? void 0 : filter.filterField) === "deal_id") {
      setOpenedFilter(null);
      navigateTo("/deal/".concat(selectedOption.id));
      return;
    }
    if (isDirectSearch) {
      var _filters;
      var existingOption = selectedOptions.find(function (option) {
        return option.id === selectedOption.id && (option === null || option === void 0 ? void 0 : option.filterField) === (filter === null || filter === void 0 ? void 0 : filter.filterField);
      });
      if (existingOption) {
        _filters = selectedOptions.filter(function (item) {
          return item.id !== existingOption.id || (item === null || item === void 0 ? void 0 : item.filterField) !== (existingOption === null || existingOption === void 0 ? void 0 : existingOption.filterField);
        });
        setTempSelectedOptions(function (pre) {
          return pre.filter(function (item) {
            return item.id !== existingOption.id || (item === null || item === void 0 ? void 0 : item.filterField) !== (existingOption === null || existingOption === void 0 ? void 0 : existingOption.filterField);
          });
        });
      } else {
        _filters = [].concat(_toConsumableArray(selectedOptions), [{
          filterField: filter === null || filter === void 0 ? void 0 : filter.filterField,
          id: selectedOption.id,
          name: selectedOption.name
        }]);
        setTempSelectedOptions(function (pre) {
          return [].concat(_toConsumableArray(pre), [{
            filterField: filter === null || filter === void 0 ? void 0 : filter.filterField,
            id: selectedOption.id,
            name: selectedOption.name
          }]);
        });
      }
      handleSearch(_filters);
      return;
    }
    setTempSelectedOptions(function (pre) {
      if (isRange) {
        var newState = pre.filter(function (item) {
          return (item === null || item === void 0 ? void 0 : item.filterField) !== (filter === null || filter === void 0 ? void 0 : filter.filterField);
        });
        newState.push({
          filterField: filter === null || filter === void 0 ? void 0 : filter.filterField,
          range_values: {
            from: selectedOption.min,
            to: selectedOption.max
          }
        });
        return newState;
      }
      var existingOption = pre.find(function (item) {
        return item.id === selectedOption.id;
      });
      if (existingOption) {
        return pre.filter(function (item) {
          return item.id !== existingOption.id;
        });
      }
      return [].concat(_toConsumableArray(pre), [{
        filterField: filter === null || filter === void 0 ? void 0 : filter.filterField,
        id: selectedOption.id,
        name: selectedOption.name,
        parent_ids: selectedOption.parent_ids || [],
        name_en: selectedOption.name_en
      }]);
    });
  };
  var handleDeleteFilters = function handleDeleteFilters(filter) {
    var filters = prepareDeletedFilters(filter, selectedOptions);
    setTempSelectedOptions([]);
    handleSearch(filters);
  };
  var handleSearch = function handleSearch(selectedFilters) {
    var paramsObject = {};
    var filteredFilters = validateFilters(selectedFilters);
    filteredFilters.forEach(function (filter) {
      var isRange = isRangeFilter(filter === null || filter === void 0 ? void 0 : filter.filterField);
      if (isRange) {
        paramsObject["".concat(filter === null || filter === void 0 ? void 0 : filter.filterField, "_from")] = filter.range_values.from;
        paramsObject["".concat(filter === null || filter === void 0 ? void 0 : filter.filterField, "_to")] = filter.range_values.to;
        return;
      }
      paramsObject[filter === null || filter === void 0 ? void 0 : filter.filterField] = paramsObject[filter === null || filter === void 0 ? void 0 : filter.filterField] ? [].concat(_toConsumableArray(paramsObject[filter === null || filter === void 0 ? void 0 : filter.filterField]), [filter.id]) : [filter.id];
    });
    var searchParams = buildSearchParams(paramsObject);
    setOpenedFilter(null);
    setTempSelectedOptions([]);
    navigateTo("/filters?".concat(searchParams));
  };
  useEffect(function () {
    getSubMenuHeight();
  }, [openedFilter, showAllTags]);
  useEffect(function () {
    setOpenedFilter(null);
  }, [location]);
  if (loading && !filters.length) return /*#__PURE__*/React.createElement(AsideFilterLoading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, isMobile && /*#__PURE__*/React.createElement(MobileFilters, {
    className: stl.mobileCssChanges,
    loading: false,
    setFilterOnMobile: setShowFilters,
    handleDeleteFilters: handleDeleteFilters,
    setFilters: function setFilters() {},
    isSideMenuOpened: openedFilter,
    selectedOptions: selectedOptions,
    sort: sort,
    location: location,
    setTempSelectedOptions: setTempSelectedOptions,
    filters: filters,
    metaData: metaData
  }), showFilters && /*#__PURE__*/React.createElement("aside", {
    id: "filter-aside-container",
    className: [stl.container, showFilters ? stl.FilterOnMobile : undefined].join(" ")
  }, /*#__PURE__*/React.createElement(AsideHeader, {
    setOpenedFilter: setOpenedFilter,
    setTempSelectedOptions: setTempSelectedOptions
  }), (filters === null || filters === void 0 ? void 0 : filters.length) > 3 && location.pathname.includes("/filters") && /*#__PURE__*/React.createElement(AsideTags, {
    selectedOptions: selectedOptions,
    id: "AsideHeight2",
    handleDeleteFilters: handleDeleteFilters,
    loading: loading,
    showAllTags: showAllTags,
    setShowAllTags: setShowAllTags,
    setTempSelectedOptions: setTempSelectedOptions,
    showMobileFilter: showFilters
  }), loading && !isSearchSaved && /*#__PURE__*/React.createElement("div", {
    className: "hidden xl:block pt-6 px-4 pb-4 border-b border-solid border-gray-gainsboro"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 25
  })), !isSearchSaved && !loading && /*#__PURE__*/React.createElement("div", {
    className: "hidden xl:block pt-6 px-4 pb-4 border-b border-solid border-gray-gainsboro"
  }, /*#__PURE__*/React.createElement(SaveSearchBanner, null)), (!isMobile || isMobile && showFilters) && /*#__PURE__*/React.createElement(AsideBody, {
    filters: filters,
    handleOpenFilter: handleOpenFilter,
    selectedOptions: selectedOptions,
    handleFilterChange: handleFilterChange,
    tempSelectedOptions: tempSelectedOptions,
    dealFacet: dealFacet,
    handleDeleteFilters: handleDeleteFilters,
    setFilterOnMobile: setShowFilters
  }), /*#__PURE__*/React.createElement(AsideSubMenu, {
    filters: filters,
    openedFilter: openedFilter,
    handleCloseFilter: handleCloseFilter,
    selectedOptions: selectedOptions,
    tempSelectedOptions: tempSelectedOptions,
    handleFilterChange: handleFilterChange,
    handleSearch: handleSearch,
    postsCount: postsCount
  }), /*#__PURE__*/React.createElement(AsideFooter, {
    count: 0,
    setFilterOnMobile: setShowFilters,
    selectedFiltersCount: 0,
    selectedOptions: selectedOptions,
    postsCount: postsCount,
    searchTerm: searchTerm
  })));
}
export default UnbxdAsideFilters;